// extracted by mini-css-extract-plugin
module.exports = {"root":"CountsSelector_root__VLCqx","rootSelected":"CountsSelector_rootSelected__IaQpd","icon":"CountsSelector_icon__oyZxM","label":"CountsSelector_label__8AiPc"};